export * from './auth.guard';



// WEBPACK FOOTER //
// C:/Users/uriel/Documents/newspaperReporteador/src/app/_guards/index.ts